export default __webpack_public_path__ + "static/media/metamask-network-rinkeby.011d989d.png";